import { makeStyles } from '@mui/styles';

import arrowRight from '../../../../assets/images/icons/arrow/chevron-right-black.svg';

export const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    padding: '32px 32px 32px 0',
  },
  arrowRight: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    width: '2rem',
    height: '2rem',
    background: `no-repeat url(${arrowRight}) center center`,
    backgroundSize: '0.625rem 1.25rem',
  },
}));
